import {Button} from '@wandb/components';
import React from 'react';

import CreateProjectDrawer from '../pages/HomePage/HomePageSidebar/CreateProjectDrawer';
import ImageIconHeader from './ImageIconHeader';
import {useNavContext, useNavUpdaterContext} from './NavContextProvider';
import {TeamProjectPaginatedList} from './PaginatedList/PaginatedProjectLists';
import * as S from './ProjectsTableTeam.styles';

export type ProjectsTableProps = {
  className?: string;
  entityName: string;
  isReadOnly: boolean;
  suppressHeader?: boolean;
  pageSize?: number | null;
  onChangePageSize?: (pageSize: number) => void;
};

const ProjectsTable: React.FC<ProjectsTableProps> = ({
  className,
  entityName,
  isReadOnly,
  suppressHeader = false,
  pageSize,
  onChangePageSize,
}) => {
  const {isCreatingProject} = useNavContext();
  const {toggleCreateProjectDrawer} = useNavUpdaterContext();

  return (
    <S.Wrapper className={className}>
      {!suppressHeader && (
        <S.HeaderWrapper>
          <ImageIconHeader icon="project" text="Projects" />
          {!isReadOnly && (
            <>
              <Button onPress={toggleCreateProjectDrawer} startIcon="add-new">
                New project
              </Button>
              <CreateProjectDrawer
                open={isCreatingProject}
                entityName={entityName}
                toggleProjectDrawer={toggleCreateProjectDrawer}
              />
            </>
          )}
        </S.HeaderWrapper>
      )}
      <TeamProjectPaginatedList
        entityName={entityName}
        isReadOnly={isReadOnly}
      />
    </S.Wrapper>
  );
};

export default ProjectsTable;
